const f = {
  color: {
    default: {
      background: "#f1f3f5ff",
      border: "#dfe6ebff",
      borderHover: "#c8d3deff"
    },
    purple: {
      background: "#fcf9ffff",
      border: "#cda9ffff",
      borderHover: "#ac6fffff"
    },
    yellow: {
      background: "#fff6e5ff",
      border: "#ffdd99ff",
      borderHover: "#fabf5aff"
    },
    cobalt: {
      background: "#ebf5ffff",
      border: "#9ecbffff",
      borderHover: "#66a3ffff"
    },
    red: {
      background: "#fff0e8ff",
      border: "#ffbcadff",
      borderHover: "#fa7a64ff"
    },
    surface: "#ffffffff",
    unread: "#4176faff",
    separator: "#abb9c7ff",
    text: {
      sources: "#131b24ff",
      meta: "#314351ff"
    }
  }
};
export {
  f as cardInsight
};
